import { NgModule } from '@angular/core';

import { EffectsModule, provideEffects } from '@ngrx/effects';
import { provideState, StoreModule } from '@ngrx/store';

import { loadTellentAssistantSuggestions } from './suggestions.effects';
import {
  TellentAssistantSuggestionsNamespace,
  TellentAssistantSuggestionsReducer,
} from './suggestions.state';

const effects = { loadTellentAssistantSuggestions };

export const provideTellentAssistantSuggestionsEffects = provideEffects(effects);

export const provideTellentAssistantSuggestionsState = provideState(
  TellentAssistantSuggestionsNamespace,
  TellentAssistantSuggestionsReducer,
);

export const provideTellentAssistantSuggestionsNgrx = [
  provideTellentAssistantSuggestionsEffects,
  provideTellentAssistantSuggestionsState,
];

@NgModule({
  imports: [
    StoreModule.forFeature(
      TellentAssistantSuggestionsNamespace,
      TellentAssistantSuggestionsReducer,
    ),
    EffectsModule.forFeature(effects),
  ],
})
export class TellentAssistantSuggestionsStoreModule {}
